import { render } from "./AppFooterBar.vue?vue&type=template&id=925fafba&scoped=true&lang=pug"
import script from "./AppFooterBar.vue?vue&type=script&lang=js"
export * from "./AppFooterBar.vue?vue&type=script&lang=js"

import "./AppFooterBar.vue?vue&type=style&index=0&id=925fafba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-925fafba"]])

export default __exports__